export const MONTHS = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"] as const;

/**
 * Month number ("01"-"12").
 */
export type Month = (typeof MONTHS)[number];
